import React from 'react';
import styles from './walkthroughSteps.module.sass';
import getSkin from './skin.js';
import { css } from 'aphrodite/no-important';
import applyWrappers from 'wrappers/ComponentWrapper';
import WalkthroughStep from './walkthroughStep';

const WalkthroughSteps = (props) => {

	const myStyles = getSkin(props.skinGuide);

	const renderSeperationLine = (index,lineClass) => {
		if (index === props.steps.length -1) {
			return null;
		}
		return (
			<div className={css(lineClass)} styleName="seperation-line"></div>
		);
	}

	const renderSteps = () => {
		return props.steps.map((step, index) => {
			let lineClass = myStyles.fadedWhite;
			if(index < props.steps.length - 1 ){
				if(props.steps[index+1].status === 'completed'){
					lineClass = myStyles.orange
				}
				else if(props.steps[index+1].status === 'inprogress'){
					lineClass = myStyles.white
				}
			}
			return (
				<div key={step.key}>
					<WalkthroughStep step={step} planning={props.planning}/>
					{renderSeperationLine(index,lineClass)}
				</div>
			);
		});
	}

	return (
		<div styleName="container">
			{renderSteps()}
		</div>
	);
}

export default applyWrappers(WalkthroughSteps, styles);